export default "../../src/img/lysiq-symbol.svg";